import { FullScreenLoading } from "components/ui/Loading/Loading";
import { useLogicalPageView } from "hooks/use-analytics-page-view";
import { usePublicFeatureFlags } from "hooks/usePublicFeatureFlags";
import type { FC } from "react";
import { Navigate } from "react-router-dom";
import LandingPageDelivery from "routes/LandingPageDelivery";

/**
 * /lp/delivery ルート: feature flag `ui.landing_page_delivery` で配信 LP の表示を制御する。
 * 読込中はローディング、flag が true でなければ /login へ送る（`ui.landing_page` とは独立）。
 * @return {JSX.Element} 配信 LP・ローディング・/login へのリダイレクトのいずれか
 */
export const LpDeliveryRoute: FC = () => {
  const { flags, loading } = usePublicFeatureFlags();
  const enabled = flags["ui.landing_page_delivery"] === true;

  // page_view はここの 1 か所だけで送る（汎用フックは /lp/delivery を送らない）。
  // 読込中・flag OFF のときは送らない。
  useLogicalPageView(!loading && enabled ? "/lp/delivery" : null);

  if (loading) {
    return <FullScreenLoading />;
  }

  if (enabled) {
    return <LandingPageDelivery />;
  }

  return <Navigate to="/login" replace />;
};
